import { useState } from 'react'

import { Address } from '@ecm/data/Address'

const useSelectedAddresses = () => {
  const [selectedAddresses, setSelectedAddresses] = useState<Address[]>([])
  return { selectedAddresses, setSelectedAddresses }
}

export default useSelectedAddresses
